import { FC, PropsWithChildren, useState } from 'react';
import { Icon } from '@/components/atomic/Icon';
import { classnames } from '@/common/utils/classnames';

export const AssetSectionAccordion: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const handleExpandClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsExpanded((prevIsExpanded) => !prevIsExpanded);
  };

  return (
    <>
      {isExpanded && children}
      <div className="flex justify-center">
        <div
          className="inline-flex cursor-pointer justify-center gap-x-1 text-xs font-medium text-gray-filled-secondary-enabled"
          onClick={handleExpandClick}
        >
          {isExpanded ? 'جزئیات کمتر' : 'جزئیات بیشتر'}
          <Icon
            className={classnames('transition', isExpanded && 'rotate-180')}
            icon="chevron_down"
            size={16}
          />
        </div>
      </div>
    </>
  );
};
